/* global appConfig */
import http from 'axios';

const base_url = `${process.env.REACT_APP_BASE_ORIGIN || '//localhost:3000'}/api/v2`;

const headers = {
  Authorization: `Bearer ${(window.appConfig && appConfig.token) || process.env.REACT_APP_AUTH_TOKEN }`
};

const get = (
  url,
  params = {}
) => http.get(`${base_url}${url}`, {
  params,
  headers
}).then(resp => resp.data);

const post = (
  url,
  data = {},
  params = {}
) => http.post(`${base_url}${url}`, data, {
  params,
  headers
}).then(resp => resp.data);

export {
  get,
  post
}



// WEBPACK FOOTER //
// ./src/api.js